// STYLE 
import './_category-selected.scss'

// LIBS
import React from 'react'
import {sortBy, includes, filter, map, get} from 'lodash/fp'
import {format} from 'date-fns'

// HELPERS
import * as util from '../../lib/util.js'

// COMPONENTS
import MetaData from '../../components/meta-data'
import BlogPostItem from '../../components/blog-post-item'

// INTERFACE
export const query = graphql`
  query CategorySelectedQuery {
    allBlogJson{
      edges {
        node {
          slug
          title
          intro
          createdAt
          categories
          imageHeader {
            fields {
              description
              file {
                url
              }
            }
          }
          blogAuthor {
            fields {
              name
              slug
              image {
                fields {
                  file {
                    url
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default ({data, location}) => {
  // grab and sort blogPost data from graphql query result (oldest to newest)
  let filterBy = location.pathname.split('/').slice(-1)[0]
  filterBy = filterBy || location.pathname.split('/').slice(-2)[0]

  let nodes = sortBy(item => new Date(item.createdAt), map(get('node'), get('allBlogJson.edges', data))).reverse()
  //console.log({location, nodes, filterBy})
  nodes = nodes.filter(node => includes(filterBy, node.categories))
  let title = filterBy.replace('-', ' ')

  title = title.toLowerCase() == 'dotnet' ? 'ASP.ET' : title
  title = title.toLowerCase() == 'ios' ? 'iOS' : title

  return (
    <div className='category-selected'> 
      <MetaData data={{
        slug: 'blog',
        title: 'Blog', 
        description: 'Code fellows blog',
      }} />
      <div style={{paddingTop: '80px'}}>
        <h2 style={{textTransform: 'capitalize', textAlign: 'center', marginBottom: '1.5em'}}>{title}</h2>
        <div>
          {nodes.map((node, i) => <BlogPostItem key={i} blogPost={node} />)}
        </div>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/templates/category-selected/index.js